import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3522a5c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "helper_wrap" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "login_box" }
const _hoisted_4 = { class: "login_content" }
const _hoisted_5 = {
  key: 0,
  class: "content_box"
}
const _hoisted_6 = { class: "login_wrap_left" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "login_wrap_right" }
const _hoisted_9 = { class: "right_conteng" }
const _hoisted_10 = { class: "right_content_title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right_content_subtitle" }, "助手登录", -1))
const _hoisted_12 = { class: "wrap_from_top" }
const _hoisted_13 = { class: "form_item" }
const _hoisted_14 = { class: "form_item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "awsc" })
], -1))
const _hoisted_16 = { class: "wrap_active" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#808080"} }, "免费注册", -1))
const _hoisted_18 = { class: "wrap_button" }
const _hoisted_19 = {
  key: 1,
  class: "error_msg"
}
const _hoisted_20 = { class: "footer" }
const _hoisted_21 = {
  key: 1,
  class: "error_msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingHeader = _resolveComponent("SingHeader")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.headerNavVisiable)
            ? (_openBlock(), _createBlock(_component_SingHeader, {
                key: 0,
                modelValue: _ctx.topLogoUrl,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.topLogoUrl) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isShowform)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _withDirectives(_createElementVNode("img", {
                        class: "login_wrap_left_img",
                        src: _ctx.LoginCover.url
                      }, null, 8, _hoisted_7), [
                        [_vShow, _ctx.LoginCover.url]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.LoginCover.title), 1),
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_a_input, {
                              class: "form_input form_item_name",
                              value: _ctx.formData.username,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.username) = $event)),
                              placeholder: "请输入账号"
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_a_input_password, {
                              class: "form_input form_input_pass",
                              value: _ctx.formData.password,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
                              placeholder: "请输入密码",
                              onKeyup: _withKeys(_ctx.login, ["enter"])
                            }, null, 8, ["value", "onKeyup"])
                          ]),
                          _hoisted_15
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_router_link, { to: "/register" }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          }),
                          _createElementVNode("p", null, [
                            _createTextVNode("已有账号去"),
                            _createVNode(_component_router_link, {
                              to: "/login",
                              style: {"color":"#1890ff"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("登录")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.login()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("登 录")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("h2", _hoisted_19, _toDisplayString(_ctx.errMsg), 1))
            ]),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.customData
              ? _ctx.customData.copyright
              : '©2019-2021 Copyright Bonwey. All rights reserved.内容监督 Tel:400-920-1599 沪ICP备16029097号'), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("h2", _hoisted_21, "请在PC端打开此页面！"))
  ]))
}